export const Animations = {
  childVariants: {
    initial: {
      opacity: 0,
      y: '50px',
    },
    final: {
      opacity: 1,
      y: '0px',
      transition: {
        duration: 0.3,
        delay: 0.2,
      },
    },
  },
  screenVariants: {
    initial: {
      x: '100vw',
      y: '0vh',
      velocity: 0,
      min: 0,
      max: 100,
      bounceStiffness: 100,
    },
    final: {
      x: '0vw',
      y: '0vh',
      transition: {
        velocity: 100,
      },
    },
  },
};
